<mwe-modal [model]="popupModel()">
  <div class="text-center">
    @if (popupData()?.title) {
      <h1 class="h4">{{ popupData()?.title }}</h1>
    }

    <div class="mb-5">
      <h2 class="h6">{{ popupData()?.newClientText }}</h2>

      @if (popupData()?.newClientTextParagraph) {
        <p class="text--big">{{ popupData()?.newClientTextParagraph }}</p>
      }

      <mwe-button
        (clicked)="startNewClientProcess()"
        [labelKey]="popupData()?.newClientButton"
        class="campaign-popup-button"
        buttonId="mwe-campaign-popup-newclient-button"
      />
    </div>

    <div>
      <h2 class="h6">{{ popupData()?.tariffChangeText }}</h2>

      @if (popupData()?.tariffChangeTextParagraph) {
        <p class="text--big">{{ popupData()?.tariffChangeTextParagraph }}</p>
      }

      <mwe-button
        (clicked)="startTariffChangeProcess()"
        [labelKey]="popupData()?.tariffChangeButton"
        class="campaign-popup-button"
        buttonId="mwe-campaign-popup-tariffchange-button"
        color="blue"
      />
    </div>
  </div>
</mwe-modal>
